// The "For MBP review" menu section and its landing page (Mohammed 20/10, TEST only for now). App.vue's setupMenu writes
// the same labels and paths out (the menu specs evaluate setupMenu on its own, so it cannot import this): a spec keeps
// the two in step.
export const REVIEW_ITEMS = [
  {
    label: 'New enquiry: one page', icon: 'pi pi-fw pi-file', to: '/newEnquiry?view=ONE_PAGE', button: 'Open',
    text: 'Today\'s Enquiry Details form, with the project, the phase and the enquiry sheet fields added, on one page.'
  },
  {
    label: 'New enquiry: tabs', icon: 'pi pi-fw pi-clone', to: '/newEnquiry?view=TABS', button: 'Open',
    text: 'The same form in three tabs (Project & enquiry, Quotation, Documents), with what is still missing counted per tab.'
  },
  {
    label: 'Projects', icon: 'pi pi-fw pi-sitemap', to: '/projects', button: 'Open',
    text: 'Every project with its phases, enquiries and quotations; open an enquiry to see its value, quotations and details.'
  },
  {
    label: 'Duplicate Projects', icon: 'pi pi-fw pi-copy', to: '/duplicateProjects', button: 'Open',
    text: 'Projects that look like the same one, side by side, for a manager to merge or dismiss (managers and Admin).'
  },
  {
    label: 'Shared Enquiry Settings', icon: 'pi pi-fw pi-cog', to: '/sharedEnquirySettings', button: 'Open',
    text: 'Which fields are mandatory, how an enquiry\'s value is worked out, and the New Enquiry form layout (Admin).'
  },
  {
    label: 'Follow-up email page (example)', icon: 'pi pi-fw pi-envelope', to: '/followUp', button: 'Open Emails Going Out',
    text: 'Click an email going out to open the page the sales exec gets the day before: edit the text, pause 1, 2 or 3 days, or stop.'
  }
]
